module.exports = __webpack_public_path__ + "img/add-blue.cdb2cfd6.svg";